import React, { useState } from "react";
import { Button } from "reactstrap";
import { Icon } from "@material-ui/core";
import { copyCodeToClipboard } from "../../../../actions";

// Shared JSON escape hatch — used for rule items the Simple View doesn't recognize, and for the
// full-config JSON View tab. Never silently drops content: parse errors block Apply, and a
// Revert button restores the last-known-good value without losing the surrounding config.
const RawJsonEditor = ({ value, onApply, minRows = 6, label }) => {
  const [text, setText] = useState(() => JSON.stringify(value, null, 2));
  const [error, setError] = useState(null);
  const [dirty, setDirty] = useState(false);

  const apply = () => {
    try {
      const parsed = JSON.parse(text);
      setError(null);
      setDirty(false);
      onApply(parsed);
    } catch (e) {
      setError(e.message);
    }
  };

  const revert = () => {
    setText(JSON.stringify(value, null, 2));
    setError(null);
    setDirty(false);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        {label && <span className="small font-weight-bold">{label}</span>}
        <span className="ml-auto">
          <Button size="sm" color="link" className="p-0 mr-3" onClick={() => copyCodeToClipboard(text)}>
            <Icon fontSize="small" className="align-middle">content_copy</Icon> Copy
          </Button>
          {dirty && (
            <>
              <Button size="sm" color="link" className="p-0 mr-3 text-danger" onClick={revert}>Revert</Button>
              <Button size="sm" color="link" className="p-0" onClick={apply}>Apply</Button>
            </>
          )}
        </span>
      </div>
      <textarea
        className="form-control"
        style={{ fontFamily: "monospace", fontSize: 12, width: "100%" }}
        rows={minRows}
        value={text}
        onChange={e => { setText(e.target.value); setDirty(true); }}
        onBlur={apply}
      />
      {error && <div className="small text-danger mt-1">Invalid JSON: {error}</div>}
    </div>
  );
};

export default RawJsonEditor;
